interface ButtonScrollToProps {
    id: string;
    text?: string;
    style?: string;
    onTrack?: () => void;
}

const ButtonScrollTo = ({ id, text = "Scroll to top", style = "secondary", onTrack }: ButtonScrollToProps) => {
    const handleClick = () => {
        onTrack?.();

        const element = document.getElementById(id);
        if (!element) {
            return;
        }

        if ("scrollBehavior" in document.documentElement.style) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } else {
            element.scrollIntoView(true);
        }
    };

    const thisClassName =
        style === "primary"
            ? "btn bg-primary text-sm text-primary-content border-none hover:bg-primary/80 min-h-0 h-[36px]"
            : "btn bg-white text-sm text-secondary-content border-none hover:bg-white/80 min-h-0 h-[36px]";

    return (
        <button className={thisClassName} onClick={handleClick}>
            {text}
        </button>
    );
};

export default ButtonScrollTo;
